import { GatsbyImage, getImage, IGatsbyImageData, ImageDataLike } from 'gatsby-plugin-image';
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface ImageProps {
    image?: Partial<ContentStackImage> | null
    alt?: string
    style?: React.CSSProperties
    className?: string
    loading?: 'eager' | 'lazy'
    [key: string]: unknown
}

const Image = ({ image, loading, alt, ...rest }: ImageProps): JSX.Element => {
    const {
        filename,
        contentStackAsset,
        description,
        url,
    } = image || {};

    const altText = alt || description || '';
    const imagePath = filename || url;

    if (imagePath && url && (imagePath.includes('.svg') || imagePath.includes('.gif'))) {
        return <img loading={loading} src={url} alt={altText} {...rest} />;
    }

    if (contentStackAsset && typeof contentStackAsset === 'object' && 'childImageSharp' in contentStackAsset && getImage(contentStackAsset?.childImageSharp as ImageDataLike)) {
        const img = getImage(contentStackAsset?.childImageSharp as ImageDataLike) as IGatsbyImageData;
        return (
            <>
                {loading === 'eager' && img.images.fallback && (
                    <Helmet>
                        <link rel="preload" as="image" href={img.images.fallback?.src} imageSrcSet={img.images.fallback?.srcSet} imageSizes={img.images.fallback?.sizes} />
                    </Helmet>
                )}
                <GatsbyImage
                    image={img}
                    alt={altText}
                    loading={loading}
                    {...rest}
                />
            </>
        );
    } if (image && getImage(image)) {
        const img = getImage(image as ImageDataLike) as IGatsbyImageData;
        return (
            <>
                {loading === 'eager' && img.images.fallback && (
                    <Helmet>
                        <link rel="preload" as="image" href={img.images.fallback?.src} imageSrcSet={img.images.fallback?.srcSet} imageSizes={img.images.fallback?.sizes} />
                    </Helmet>
                )}
                <GatsbyImage
                    image={img}
                    alt={altText}
                    loading={loading}
                    {...rest}
                />
            </>
        );
    }

    if (imagePath && url) {
        return <img loading={loading} src={url} alt={altText} {...rest} />;
    }

    // Should be able to function as a 'box' layout wise even with a missing image
    return <div {...rest} />;
};

export default Image;
